import { createWebHistory, createRouter } from "vue-router";

const routes = [
  {
    path: "/",
    name: "index",
    component: () => import('@/pages/index/index-seven.vue'),
    meta: {
      title: "Latest Jobs & Vacancies in Kenya (No Registration) | Zuri HR Jobs",
      description: "Apply directly for top job openings in Kenya. Discover daily updated vacancies in IT, HR, Sales, Finance, Engineering, and Administration on Zuri HR Jobs Corner."
    }
  },
  {
    path: "/job-categories",
    name: "job-categories",
    component: () => import('@/pages/jobs/job-categories.vue'),
    meta: {
      title: "Browse Jobs by Industry & Category in Kenya | Zuri HR Jobs",
      description: "Filter recent vacancies by category. Find jobs in IT, Sales, Human Resource, Engineering, Finance, and Administration on Zuri HR."
    }
  },
  {
    path: "/job-listing",
    name: "job-listing",
    component: () => import('@/pages/jobs/job-grid/job-grid-four.vue'),
    meta: {
      title: "Search Jobs, Internships & Careers in Kenya | Zuri HR Jobs",
      description: "Filter and search active job listings. Find remote, full-time, or part-time jobs in Nairobi and across Kenya. Apply instantly with your resume."
    }
  },
  {
    path: "/zuri-hr-job-detail",
    name: "zuri-hr-job-details",
    component: () => import('@/pages/jobs/job-detail/job-detail-one.vue'),
    meta: {
      title: "Job Requirements & Details | Zuri HR Jobs Portal",
      description: "Find job specs, required experience, salary structure, and application guidelines for job vacancies on Zuri HR."
    }
  },
  {
    path: "/zuri-hr-job-detail/:id",
    name: "zuri-hr-job-detail",
    component: () => import('@/pages/jobs/job-detail/job-detail-one.vue'),
    meta: {
      title: "Job Requirements & Details | Zuri HR Jobs Portal",
      description: "Find job specs, required experience, salary structure, and application guidelines for job vacancies on Zuri HR."
    }
  },
  {
    path: "/job-apply",
    name: "job-applys",
    component: () => import('@/pages/jobs/job-apply.vue'),
    meta: {
      title: "Submit Job Application Online | Zuri HR Jobs",
      description: "Easy and direct application form. Upload your PDF CV and apply for job vacancies in minutes without signing up."
    }
  },
  {
    path: "/job-apply/:id",
    name: "job-apply",
    component: () => import('@/pages/jobs/job-apply.vue'),
    meta: {
      title: "Submit Job Application Online | Zuri HR Jobs",
      description: "Easy and direct application form. Upload your PDF CV and apply for job vacancies in minutes without signing up."
    }
  },
  {
    path: "/aboutus",
    name: "aboutus",
    component: () => import('@/pages/pages/aboutus.vue'),
    meta: {
      title: "About Zuri HR – Connecting Top Talent with Leading Employers",
      description: "Discover how Zuri HR Jobs Corner makes recruitment and job hunting seamless in Kenya. Our mission is to bridge the gap between talent and opportunities."
    }
  },
  {
    path: "/comingsoon",
    name: "comingsoon",
    component: () => import('@/pages/special-page/comingsoon.vue'),
    meta: {
      title: "New Job Features Coming Soon | Zuri HR Jobs Portal",
      description: "Our platform is undergoing updates. Stay tuned for new career tools and job search enhancements."
    }
  },
  {
    path: "/maintenance",
    name: "maintenance",
    component: () => import('@/pages/special-page/maintenance.vue'),
    meta: {
      title: "Under Scheduled Maintenance | Zuri HR Jobs Portal",
      description: "Zuri HR Jobs Portal is currently undergoing scheduled maintenance. We'll be back shortly to assist your job search."
    }
  },
  {
    path: "/thankyou",
    name: "thankyou",
    component: () => import('@/pages/special-page/thankyou.vue'),
    meta: {
      title: "Application Received - Thank You | Zuri HR Jobs",
      description: "Thank you for applying. Zuri HR has successfully received your job application. The employer will contact you directly."
    }
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import('@/pages/contact.vue'),
    meta: {
      title: "Contact Zuri HR – Jobs Portal Support & Employer Inquiries",
      description: "Get in touch with Zuri HR support team. Reach out for corporate recruitment, job posting queries, technical help, or business partnerships."
    }
  },
  {
    path: "/:error(.*)",
    name: "error",
    component: () => import('@/pages/special-page/error.vue'),
    meta: {
      title: "404 Page Not Found | Zuri HR Jobs Corner",
      description: "The page you are looking for does not exist. Return to Zuri HR Jobs Corner homepage to find active vacancies."
    }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  // Update title
  const title = to.meta.title || "Zuri HR Jobs – Discover Your Next Career Opportunity";
  document.title = title;

  // Update description
  const description = to.meta.description || "Search and apply for top jobs in Kenya and beyond with Zuri HR Jobs Corner.";
  let metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute('content', description);
  } else {
    metaDescription = document.createElement('meta');
    metaDescription.setAttribute('name', 'description');
    metaDescription.setAttribute('content', description);
    document.head.appendChild(metaDescription);
  }
  
  next();
});

export default router;